import React from "react";
import DiceDreamsCheckoutSkeleton from "./DiceDreamsCheckoutSkeleton";
import GameCardSkeleton from "./GameCardSkeleton";
import PaymentMethodsListSkeleton from "./PaymentMethodsListSkeleton";
import { Skeleton } from "@/components/ui/skeleton";

const CheckoutFormSkeleton = () => {
  // Note: Skeleton always shows with bg=enabled style (original layout)
  // The actual CheckoutForm will apply bg=disabled styles when needed
  return (
    <div className="flex flex-1 flex-col landscape:flex-row landscape:overflow-hidden">
      <div className="landscape:bg-[#F7F7F7] landscape:w-1/2 flex flex-col">
        <div className="flex flex-1 flex-col w-full mx-auto landscape:mb-[21px]">
          <div className="flex-1">
            <DiceDreamsCheckoutSkeleton />
            <GameCardSkeleton />
          </div>

          <div className='block portrait:hidden text-center'>
            <Skeleton className="h-[16px] w-[100px] mx-auto mb-1" />
          </div>
          
          <div className="text-center hidden landscape:block mx-6">
            <Skeleton className="h-[16px] w-[300px] mx-auto mb-2" />
            <Skeleton className="h-[16px] w-[250px] mx-auto" />
          </div>
          <div className="h-[1px] bg-[#ECECEC] w-full mb-4 landscape:hidden" />
        </div>
      </div>

      <div className="flex flex-1 w-full landscape:w-1/2 flex-col pb-[17px] landscape:pt-[17px] landscape:pb-4 landscape:bg-white landscape:overflow-auto">
        <Skeleton className="mb-2 md:mb-3 landscape:mb-4 mx-5 h-[20px] w-[150px]" />
        <PaymentMethodsListSkeleton />
        
        {/* Safe transaction info skeleton */}
        <section className="flex flex-col items-center text-[#212121] font-normal px-8 mt-4">
          <div className="flex items-center gap-2 my-2 landscape:my-1">
            <Skeleton className="w-[13px] h-[13px] rounded-full" />
            <Skeleton className="h-[16px] w-[150px]" />
          </div>
          <div className="text-center landscape:hidden">
            <Skeleton className="h-[16px] w-[280px] mx-auto mb-1" />
            <Skeleton className="h-[16px] w-[250px] mx-auto" />
          </div>
        </section>
      </div>
    </div>
  );
};

export default React.memo(CheckoutFormSkeleton);
